import { Component } from '@verndale/core';
import clickOutside from 'click-outside';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $hamburger: this.el._$('.heaer__hamburger'),
      $panel: this.el._$('.heaer__panel'),
      $search: this.el._$('.header-search'),
      $searchTrigger: this.el._$('.header-search__trigger'),
      $searchForm: this.el._$('.header-search__form'),
      $searchField: this.el._$('.header-search__field')
    };

    this.expamdedClass = 'header--expanded';
    this.searchOpenedClass = 'header-search--opened';
  }

  addListeners() {
    this.dom.$hamburger._on('click', this.toggle.bind(this));
    this.dom.$searchTrigger._on('click', this.toggleSearch.bind(this));
    this.dom.$searchForm._on('reset', this.closeSearch.bind(this));
    this.dom.$searchField._on('keydown', this.closeSearchOnEsc.bind(this));
    this.dom.$searchForm._on('submit', this.validateBeforeSubmit.bind(this));
    clickOutside(this.dom.$el, this.onClickOutside.bind(this));
    clickOutside(this.dom.$search, this.closeSearch.bind(this));
  }

  toggle() {
    this.dom.$el.classList.toggle(this.expamdedClass);
  }

  onClickOutside() {
    this.dom.$el.classList.remove(this.expamdedClass);
  }

  openSearch() {
    this.dom.$search.classList.add(this.searchOpenedClass);
    this.dom.$searchField.focus();
  }

  closeSearch() {
    this.dom.$search.classList.remove(this.searchOpenedClass);
  }

  toggleSearch() {
    if (this.dom.$search.classList.contains(this.searchOpenedClass)) {
      this.closeSearch();
    } else {
      this.openSearch();
    }
  }

  closeSearchOnEsc(e) {
    if (e.which === 27) this.closeSearch()
  }

  validateBeforeSubmit(e) {
    if (!this.dom.$searchField.value) {
      e.preventDefault();
    }
  }
}

export default Module;
